import { Component, Input } from '@angular/core';
import { NgClass } from '@angular/common';
import { MatIcon } from '@angular/material/icon';

@Component({
	selector: 'app-access-horizontal-stepper-labels',
	templateUrl: './access-horizontal-stepper-labels.component.html',
	styleUrls: ['./access-horizontal-stepper-labels.component.scss'],
	imports: [NgClass, MatIcon],
})
export class AccessHorizontalStepperLabelsComponent {
	@Input() steps: string[] = [];
	@Input() currentStep: number = 0;

	constructor() {}
}
